import { useObserver } from 'mobx-react';
import { useGetSpecialGamificationQuery, GqlGetSpecialGamificationQuery } from 'types/graphql';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useCart from 'hooks/use-cart';
import { toUppercaseMenuType } from 'shared/constants';

type UseSpecialGamificationProps = {
  // these should be the sourceId not the mongo id
  specialIds: string[];
  skip: boolean;
};

type UseSpecialGamificationResponse = {
  gamificationThresholds?: NonNullable<
    GqlGetSpecialGamificationQuery['getSpecialGamification']
  >['gamificationThresholds'];
  loading: boolean;
  error?: Error;
};

export default function useSpecialGamification({
  specialIds,
  skip,
}: UseSpecialGamificationProps): UseSpecialGamificationResponse {
  const cart = useCart();
  const cartDispensary = useObserver(() => cart.dispensary);
  // Need to add a fallback for when the cart is empty
  const { dispensary: fallbackDispensary } = useDispensary();
  const dispensary = cartDispensary ?? fallbackDispensary;
  const menuType = useObserver(() => cart.menuType);
  const discountSyncEnabled = dispensary?.storeSettings?.enableLLxSaleDiscountSync;

  const skipQuery = skip || !dispensary?.id || !specialIds.length || !discountSyncEnabled;

  const { data, loading, error } = useGetSpecialGamificationQuery({
    variables: {
      dispensaryId: dispensary?.id,
      menuType: toUppercaseMenuType(menuType),
      specialIds,
    },
    skip: skipQuery,
  });

  return {
    gamificationThresholds: data?.getSpecialGamification?.gamificationThresholds,
    loading,
    error,
  };
}
